<template>

  <modalo
    :title="departament.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => departament">

    <form id="departament-form" v-on:submit.prevent="saveDepartament(departament)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="departament.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="departament-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteDepartament(departament._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'DepartamentForm',
  components: {
  },
  props: [
    'initDepartament'
  ],
  data () {
    return {
      loading: false,
      departament: this.defaultValues(this.initDepartament),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveDepartament
    */
    saveDepartament (data) {
      if (data._id) this.updateDepartament(data)
      else this.createDepartament(data)
    },
    /*
    createDepartament
    */
    createDepartament (data) {
      this.loading = true

      this.$store
      .dispatch('createDepartament', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateDepartament
    */
    updateDepartament (data) {
      this.loading = true

      this.$store
      .dispatch('updateDepartament', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteDepartament (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDepartament', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Departament/DepartamentForm.vue